import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import _ from '@lodash';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmDialog from 'modules/ui/component/ConfirmDialog';
import { IconButton, Tooltip, TableCell } from '@material-ui/core';

function TableDeleteButton(props) {
	const { t } = useTranslation('tableBrowser');
	const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
	const getDeleteItemName = () => {
		if (!props.item) return null;

		const configuredName = props.config?.deleteItemName;
		const value = _.isFunction(configuredName)
			? configuredName(props.item)
			: configuredName
			? _.get(props.item, configuredName)
			: props.item.name || _.get(props.item, props.config?.columns?.find(column => column.key === 'name')?.key) || _.get(props.item, props.config?.columns?.find(column => column.type === 'text')?.key);

		if (_.isObject(value)) {
			return value.name || value.text || value.label || value.title || value.id || null;
		}

		return value === null || _.isUndefined(value) || value === '' ? null : value;
	};
	const deleteItemName = getDeleteItemName();

	return (
		<TableCell className="w-auto text-center" padding="none">
			<Tooltip title={t('DELETE')}>
				<span>
					<IconButton
						aria-label="delete"
						onClick={e => {
							setShowDeleteConfirm(true);
							e.preventDefault();
						}}
						disabled={props.item && props.item.protectionLevel && (props.item.protectionLevel === 'CannotBeDeleted' || props.item.protectionLevel === 'CannotBeModified')}
					>
						<DeleteIcon fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>
			<ConfirmDialog
				show={showDeleteConfirm}
				title={t('DELETE')}
				description={deleteItemName ? t('DELETE_DESC_WITH_NAME', { itemName: deleteItemName }) : t('DELETE_DESC')}
				onYes={() => props.onDelete()}
				onClose={() => setShowDeleteConfirm(false)}
			/>
		</TableCell>
	);
}

export default TableDeleteButton;
